import axios from "axios";

const Axios = {}
Axios.install = function (Vue, options = {}) {
    Object.defineProperty(Vue.prototype, '$axios', {
        get: function () {
            const user = this.$store.state['oauth2'].user;
            const accessToken = (user && user.token) || null;
            return axios.create({
                ...options,
                headers: {
                    ...(options.headers || {}),
                    ...(accessToken ? {'Authorization': `Bearer ${accessToken}`} : {})
                }
            })
        }
    })
}

export default Axios
